/**
 * Header country dropdown: toggle active on trigger click, close on outside click.
 */
(function () {
  function initCountryDropdown() {
    const trigger = document.querySelector('.header__title-country-flag');
    const dropdown = document.querySelector('.header__dropdown-country');
    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropdown.classList.toggle('active');
    });

    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('active');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountryDropdown);
  } else {
    initCountryDropdown();
  }
})();
